import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { API } from 'src/store/api'
import { matchPathCallback } from 'src/utils/history'

// 获取订单page
export const getOrderPage = createAsyncThunk('user/getOrderPage', async (params, thunkAPI) => {
  const response = await API.getOrderPage(params)
  return response.data
})
// 检查是否有号源
export const getNoAppointmentTimes = createAsyncThunk(
  'user/getNoAppointmentTimes',
  async (params, thunkAPI) => {
    const response = await API.getNoAppointmentTimes(params)
    return response.data
  },
)
// 检查医生所有号源情况
export const getAllBookings = createAsyncThunk('user/getAllBookings', async (params, thunkAPI) => {
  const response = await API.getAllBookings(params)
  return response.data
})
// 检查选择时间后医生所有号源情况
export const getDoctorBookings = createAsyncThunk(
  'doctors/getBookingsInDoctorList',
  async (params, thunkAPI) => {
    const response = await API.getDoctorBookings(params)
    return response.data
  },
)
// 创建订单
export const addOrder = createAsyncThunk('user/add-order', async (params, thunkAPI) => {
  const response = await API.addOrder(params)
  return response.data
})
// 取消订单
export const cancelOrder = createAsyncThunk('user/cancelOrder', async (params, thunkAPI) => {
  const response = await API.cancelOrder(params)
  return response.data
})
// 更新订单
export const updateOrder = createAsyncThunk('user/updateOrder', async (params, thunkAPI) => {
  const response = await API.updateOrder(params)
  return response.data
})
// 获取订单信息
export const getOrderInfo = createAsyncThunk('user/getOrderInfo', async (params, thunkAPI) => {
  const response = await API.getOrderInfo(params)
  return response.data
})
// 获取报告page
export const getReportPage = createAsyncThunk('user/getReportPage', async (params, thunkAPI) => {
  const response = await API.getReportPage(params)
  return response.data
})
// 支付
export const pay = createAsyncThunk('user/pay', async (params, thunkAPI) => {
  const response = await API.pay(params)
  return response
})
// 申请退款
export const applyRefund = createAsyncThunk('user/applyRefund', async (params, thunkAPI) => {
  const response = await API.applyRefund(params)
  return response.data
})
// 申请退款
export const cancelRefund = createAsyncThunk('user/cancelRefund', async (params, thunkAPI) => {
  const response = await API.cancelRefund(params)
  return response.data
})
// 问卷场景一
export const orderSuccessFaq = createAsyncThunk('orderSuccessFaq/add', async (params, thunkAPI) => {
  const response = await API.orderSuccessFaq(params)
  return response.data
})
// 问卷场景2
export const cancerOrderFaq = createAsyncThunk('cancerOrderFaq/add', async (params, thunkAPI) => {
  const response = await API.cancerOrderFaq(params)
  return response.data
})
// 问卷场景3
export const applyRefundFaq = createAsyncThunk('applyRefundFaq/add', async (params, thunkAPI) => {
  const response = await API.applyRefundFaq(params)
  return response.data
})
// 获取atome数据
export const getPaymentInfo = createAsyncThunk('user/getPaymentInfo', async (params, thunkAPI) => {
  const response = await API.getPaymentInfo(params)
  return response.data
})
// atome支付
export const payAtome = createAsyncThunk('user/payAtome', async (params, thunkAPI) => {
  const response = await API.payAtome(params)
  return response
})
// 获取产品价格单位
export const getPrice = createAsyncThunk('testCenters/getPrice', async (params, thunkAPI) => {
  const response = await API.getPrice(params)
  return response
})

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    orderList: [],
    orderPagination: {
      page: 1,
      size: 10,
      total: 0,
    },
    orderListStatus: false,
    orderInfo: null,
    priceAndCurrency: null,
    orderInfoStatus: '',
    addOrderStatus: '',
    cancelOrderStatus: '',
    reportList: [],
    reportPagination: null,
    reportListStatus: '',
    reportInfo: null,
    payStatus: '',
    payAtomeStatus: '',
    paymentInfo: '',
    applyRefundStatus: '',
    cancelRefundStatus: '',
    noAppointmentTimesStatus: '',
  },
  reducers: {
    setOrderExpired(state, action) {
      const { orderNumber } = action.payload
      const order = state.orderList?.find((item) => item.orderNumber === orderNumber)
      if (order) {
        order.payStatus = 2
      }
    },
    resetCancerOrderFaq(state, action) {
      state.resetCancerOrderFaqStatus = ''
    },
  },
  // reducers 支持两种不同的形式
  // 1、builder callback
  // 2、map object
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    // 获取订单page
    builder.addCase(getOrderPage.pending, (state, action) => {
      state.orderListStatus = 'pending'
    })
    builder.addCase(getOrderPage.fulfilled, (state, action) => {
      state.orderListStatus = 'fulfilled'
      const { list, pagination } = action.payload
      state.orderList = [...(list || [])]
      state.orderPagination = pagination
    })
    builder.addCase(getOrderPage.rejected, (state, action) => {
      state.orderListStatus = 'rejected'
    })
    // 检查是否有号源
    builder.addCase(getNoAppointmentTimes.pending, (state, action) => {
      state.noAppointmentTimesStatus = 'pending'
    })
    builder.addCase(getNoAppointmentTimes.fulfilled, (state, action) => {
      state.noAppointmentTimesStatus = 'fulfilled'
    })
    builder.addCase(getNoAppointmentTimes.rejected, (state, action) => {
      state.noAppointmentTimesStatus = 'rejected'
    })

    // 检查医生所有号源情况

    builder.addCase(getAllBookings.rejected, (state, action) => {})

    // 检查选择时间后所有号源情况
    builder.addCase(getDoctorBookings.fulfilled, (state, action) => {
      state.bookingsStatus = 'fulfilled'

      state.bookings = action.payload
    })
    builder.addCase(getDoctorBookings.rejected, (state, action) => {})
    // 创建订单
    builder.addCase(addOrder.pending, (state, action) => {
      state.addOrderStatus = 'pending'
    })
    builder.addCase(addOrder.fulfilled, (state, action) => {
      state.addOrderStatus = 'fulfilled'
      if (!action.payload) return
    })
    builder.addCase(addOrder.rejected, (state, action) => {
      state.addOrderStatus = 'rejected'
    })
    // 取消订单
    builder.addCase(cancelOrder.pending, (state, action) => {
      state.cancelOrderStatus = 'pending'
    })
    builder.addCase(cancelOrder.fulfilled, (state, action) => {
      state.cancelOrderStatus = 'fulfilled'
      if (!action.payload) return
    })
    builder.addCase(cancelOrder.rejected, (state, action) => {
      state.cancelOrderStatus = 'rejected'
    })
    // 订单信息
    builder.addCase(getOrderInfo.pending, (state, action) => {
      state.orderInfoStatus = 'pending'
    })
    builder.addCase(getOrderInfo.fulfilled, (state, action) => {
      state.orderInfoStatus = 'fulfilled'
      if (!action.payload) return
      state.orderInfo = action.payload
    })
    builder.addCase(getOrderInfo.rejected, (state, action) => {
      state.orderInfoStatus = 'rejected'
      state.orderInfo = null
    })
    // 支付
    builder.addCase(pay.pending, (state, action) => {
      state.payStatus = 'pending'
    })
    builder.addCase(pay.fulfilled, (state, action) => {
      matchPathCallback({
        routes: '/add-order',
        match: () => window.location.replace(action.payload),
        noMatch: () => {
          window.location = action.payload
        },
      })
      state.payStatus = 'fulfilled'
    })
    builder.addCase(pay.rejected, (state, action) => {
      state.payStatus = 'rejected'
    })
    // atome支付
    builder.addCase(payAtome.pending, (state, action) => {
      state.payAtomeStatus = 'pending'
    })
    builder.addCase(payAtome.fulfilled, (state, action) => {
      matchPathCallback({
        routes: '/add-order',
        match: () => window.location.replace(action.payload),
        noMatch: () => {
          window.location = action.payload
        },
      })
      state.payAtomeStatus = 'fulfilled'
    })
    builder.addCase(payAtome.rejected, (state, action) => {
      state.payAtomeStatus = 'rejected'
    })

    // 获取价格
    builder.addCase(getPrice.pending, (state, action) => {
      state.getPriceStatus = 'pending'
    })
    builder.addCase(getPrice.fulfilled, (state, action) => {
      state.getPriceStatus = 'fulfilled'
      if (!action.payload) return
      state.priceAndCurrency = action.payload.data[0]
    })
    builder.addCase(getPrice.rejected, (state, action) => {
      state.getPriceStatus = 'rejected'
    })

    // 申请退款
    builder.addCase(cancelRefund.pending, (state, action) => {
      state.cancelRefundStatus = 'pending'
    })
    builder.addCase(cancelRefund.fulfilled, (state, action) => {
      state.cancelRefundStatus = 'fulfilled'
    })
    builder.addCase(cancelRefund.rejected, (state, action) => {
      state.cancelRefundStatus = 'rejected'
      if (action.error?.message) {
        window.location.reload()
      }
    })
    // 取消退款
    builder.addCase(applyRefund.pending, (state, action) => {
      state.applyRefundStatus = 'pending'
    })
    builder.addCase(applyRefund.fulfilled, (state, action) => {
      state.applyRefundStatus = 'fulfilled'
    })
    builder.addCase(applyRefund.rejected, (state, action) => {
      state.applyRefundStatus = 'rejected'
    })
    // 获取报告page
    builder.addCase(getReportPage.pending, (state, action) => {
      state.reportListStatus = 'pending'
    })
    builder.addCase(getReportPage.fulfilled, (state, action) => {
      state.reportListStatus = 'fulfilled'
      const { list, pagination } = action.payload
      state.reportList = [...(list || [])]
      state.reportPagination = pagination
    })
    builder.addCase(getReportPage.rejected, (state, action) => {
      state.reportListStatus = 'rejected'
    })
    // 获取atome信息
    builder.addCase(getPaymentInfo.pending, (state, action) => {
      state.getPaymentInfoStatus = 'pending'
    })
    builder.addCase(getPaymentInfo.fulfilled, (state, action) => {
      state.getPaymentInfoStatus = 'fulfilled'
      if (!action.payload) return
      state.paymentInfo = action.payload
    })
    builder.addCase(getPaymentInfo.rejected, (state, action) => {
      state.getPaymentInfoStatus = 'rejected'
    })
    // 问卷一
    builder.addCase(orderSuccessFaq.pending, (state, action) => {
      state.orderSuccessFaqStatus = 'pending'
    })
    builder.addCase(orderSuccessFaq.fulfilled, (state, action) => {
      state.orderSuccessFaqStatus = 'fulfilled'
    })
    builder.addCase(orderSuccessFaq.rejected, (state, action) => {
      state.orderSuccessFaqStatus = 'rejected'
      if (action.error?.message) {
        console.log(action.error?.message)
      }
    })
    // 问卷2
    builder.addCase(cancerOrderFaq.pending, (state, action) => {
      state.resetCancerOrderFaqStatus = 'pending'
    })
    builder.addCase(cancerOrderFaq.fulfilled, (state, action) => {
      state.resetCancerOrderFaqStatus = 'fulfilled'
    })
    builder.addCase(cancerOrderFaq.rejected, (state, action) => {
      state.resetCancerOrderFaqStatus = 'rejected'
      if (action.error?.message) {
        console.log(action.error?.message)
      }
    })
    // 问卷3
    builder.addCase(applyRefundFaq.pending, (state, action) => {
      state.applyRefundFaqStatus = 'pending'
    })
    builder.addCase(applyRefundFaq.fulfilled, (state, action) => {
      state.applyRefundFaqStatus = 'fulfilled'
    })
    builder.addCase(applyRefundFaq.rejected, (state, action) => {
      state.applyRefundFaqStatus = 'rejected'
      if (action.error?.message) {
        console.log(action.error?.message)
      }
    })
  },
})

// Action creators are generated for each case reducer function
export const { setOrderExpired, resetCancerOrderFaq } = userSlice.actions
export default userSlice.reducer
